"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 13 16';

var Print = function Print() {
  return _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M9.41645,14.0360258 C9.41645,14.2311226 9.26245,14.3906065 9.07345,14.3906065 L4.04245,14.3906065 C3.85345,14.3906065 3.69945,14.2311226 3.69945,14.0360258 L3.69945,10.4974452 L9.41645,10.4974452 L9.41645,14.0360258 Z M11.27595,9.90699355 C11.27595,9.58131613 11.01995,9.31654194 10.70395,9.31654194 L2.34345,9.31654194 C2.02745,9.31654194 1.77145,9.58131613 1.77145,9.90699355 C1.77145,10.2331871 2.02745,10.4974452 2.34345,10.4974452 L2.55595,10.4974452 L2.55595,14.0360258 C2.55595,14.8824774 3.22295,15.5704774 4.04245,15.5704774 L9.07345,15.5704774 C9.89295,15.5704774 10.55995,14.8824774 10.55995,14.0360258 L10.55995,10.4974452 L10.70395,10.4974452 C11.01995,10.4974452 11.27595,10.2331871 11.27595,9.90699355 L11.27595,9.90699355 Z"
  }), _react["default"].createElement("path", {
    d: "M3.6997,1.63581935 C3.6997,1.44020645 3.8537,1.28123871 4.0427,1.28123871 L9.0737,1.28123871 C9.2627,1.28123871 9.4167,1.44020645 9.4167,1.63581935 L9.4167,3.52381935 L10.5602,3.52381935 L10.5602,1.63581935 C10.5602,0.789367742 9.8932,0.100851613 9.0737,0.100851613 L4.0427,0.100851613 C3.2232,0.100851613 2.5562,0.789367742 2.5562,1.63581935 L2.5562,3.52381935 L3.6997,3.52381935 L3.6997,1.63581935 Z"
  }), _react["default"].createElement("path", {
    d: "M11.6025,4.10100645 L1.516,4.10100645 C0.7575,4.10100645 0.1395,4.73790968 0.1395,5.52139355 L0.1395,11.3392 C0.1395,12.1226839 0.7575,12.7595871 1.516,12.7595871 L2.088,12.7595871 L2.088,11.5792 L1.516,11.5792 C1.3875,11.5792 1.283,11.4718452 1.283,11.3392 L1.283,5.52139355 C1.283,5.38874839 1.3875,5.28087742 1.516,5.28087742 L11.6025,5.28087742 C11.731,5.28087742 11.835,5.38874839 11.835,5.52139355 L11.835,11.3392 C11.835,11.4718452 11.731,11.5792 11.6025,11.5792 L11.0305,11.5792 L11.0305,12.7595871 L11.6025,12.7595871 C12.3615,12.7595871 12.9785,12.1226839 12.9785,11.3392 L12.9785,5.52139355 C12.9785,4.73790968 12.3615,4.10100645 11.6025,4.10100645"
  }));
};

var _default = (0, _createSvgIcon["default"])(Print, {
  viewBox: viewBox
});

exports["default"] = _default;